const AmericanCountriesList = [
    { value: 'US', region: 'us/en', reg: 'us', name: 'United States of America' },
    { value: 'CA', region: 'ca/en', reg: 'ca', name: 'Canada' },
    { value: 'AS', region: 'sg/en', reg: 'sg', name: 'American Samoa' },
    { value: 'GU', region: 'sg/en', reg: 'sg', name: 'Guam' },
    { value: 'MH', region: 'sg/en', reg: 'sg', name: 'Marshall Islands' },
    { value: 'FM', region: 'sg/en', reg: 'sg', name: 'Micronesia' },
    { value: 'MP', region: 'sg/en', reg: 'sg', name: 'Northern Mariana Islands' },
    { value: 'PW', region: 'sg/en', reg: 'sg', name: 'Palau' },
    { value: 'UM', region: 'sg/en', reg: 'sg', name: 'U.S. Outlying Islands' },
    { value: 'AG', region: 'us/en', reg: 'us', name: 'Antigua and Barbuda' },
    { value: 'AI', region: 'us/en', reg: 'us', name: 'Anguilla' },
    { value: 'AR', region: 'us/en', reg: 'us', name: 'Argentina' },
    { value: 'AW', region: 'us/en', reg: 'us', name: 'Aruba' },
    { value: 'BB', region: 'us/en', reg: 'us', name: 'Barbados' },
    { value: 'BL', region: 'us/en', reg: 'us', name: 'Saint Barth̩lemy' },
    { value: 'BM', region: 'us/en', reg: 'us', name: 'Bermuda' },
    { value: 'BO', region: 'us/en', reg: 'us', name: 'Bolivia' },
    { value: 'BQ', region: 'us/en', reg: 'us', name: 'Bonaire, Sint Eustatius and Saba' },
    { value: 'BR', region: 'us/en', reg: 'us', name: 'Brazil' },
    { value: 'BS', region: 'us/en', reg: 'us', name: 'Bahamas' },
    { value: 'BV', region: 'us/en', reg: 'us', name: 'Bouvet Island' },
    { value: 'BZ', region: 'us/en', reg: 'us', name: 'Belize' },
    { value: 'CL', region: 'us/en', reg: 'us', name: 'Chile' },
    { value: 'CO', region: 'us/en', reg: 'us', name: 'Colombia' },
    { value: 'CR', region: 'us/en', reg: 'us', name: 'Costa Rica' },
    { value: 'CU', region: 'us/en', reg: 'us', name: 'Cuba' },
    { value: 'CW', region: 'us/en', reg: 'us', name: 'Cura̤ao' },
    { value: 'DM', region: 'us/en', reg: 'us', name: 'Dominica' },
    { value: 'DO', region: 'us/en', reg: 'us', name: 'Dominican Republic' },
    { value: 'EC', region: 'us/en', reg: 'us', name: 'Ecuador' },
    { value: 'FK', region: 'us/en', reg: 'us', name: 'Falkland Islands' },
    { value: 'GD', region: 'us/en', reg: 'us', name: 'Grenada' },
    { value: 'GF', region: 'us/en', reg: 'us', name: 'French Guiana' },
    { value: 'GL', region: 'us/en', reg: 'us', name: 'Greenland' },
    { value: 'GP', region: 'us/en', reg: 'us', name: 'Guadeloupe' },
    { value: 'GS', region: 'us/en', reg: 'us', name: 'South Georgia and the South Sandwich Islands' },
    { value: 'GT', region: 'us/en', reg: 'us', name: 'Guatemala' },
    { value: 'GY', region: 'us/en', reg: 'us', name: 'Guyana' },
    { value: 'HN', region: 'us/en', reg: 'us', name: 'Honduras' },
    { value: 'HT', region: 'us/en', reg: 'us', name: 'Haiti' },
    { value: 'JM', region: 'us/en', reg: 'us', name: 'Jamaica' },
    { value: 'KN', region: 'us/en', reg: 'us', name: 'Saint Kitts and Nevis' },
    { value: 'KY', region: 'us/en', reg: 'us', name: 'Cayman Islands' },
    { value: 'LC', region: 'us/en', reg: 'us', name: 'Saint Lucia' },
    { value: 'MF', region: 'us/en', reg: 'us', name: 'Saint Martin (French part)' },
    { value: 'MQ', region: 'us/en', reg: 'us', name: 'Martinique' },
    { value: 'MS', region: 'us/en', reg: 'us', name: 'Montserrat' },
    { value: 'MX', region: 'us/en', reg: 'us', name: 'Mexico' },
    { value: 'NI', region: 'us/en', reg: 'us', name: 'Nicaragua' },
    { value: 'PA', region: 'us/en', reg: 'us', name: 'Panama' },
    { value: 'PE', region: 'us/en', reg: 'us', name: 'Peru' },
    { value: 'PM', region: 'us/en', reg: 'us', name: 'Saint Pierre and Miquelon' },
    { value: 'PR', region: 'us/en', reg: 'us', name: 'Puerto Rico' },
    { value: 'PY', region: 'us/en', reg: 'us', name: 'Paraguay' },
    { value: 'SR', region: 'us/en', reg: 'us', name: 'Suriname' },
    { value: 'SV', region: 'us/en', reg: 'us', name: 'El Salvador' },
    { value: 'SX', region: 'us/en', reg: 'us', name: 'Sint Maarten (Dutch part)' },
    { value: 'TC', region: 'us/en', reg: 'us', name: 'Turks and Caicos Islands' },
    { value: 'TT', region: 'us/en', reg: 'us', name: 'Trinidad and Tobago' },
    { value: 'UY', region: 'us/en', reg: 'us', name: 'Uruguay' },
    { value: 'VC', region: 'us/en', reg: 'us', name: 'Saint Vincent and the Grenadines' },
    { value: 'VE', region: 'us/en', reg: 'us', name: 'Venezuela (Bolivarian Republic of)' },
    { value: 'VG', region: 'us/en', reg: 'us', name: 'Virgin Islands (British)' },
    { value: 'VI', region: 'us/en', reg: 'us', name: 'Virgin Islands (U.S.)' },
  ];
  export default AmericanCountriesList;
  